import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { listCurrentUserRegistration } from "../utils/client";
import { RegistrationSummary } from "baptize-america-client";
import {
  fetchUserAttributes,
  FetchUserAttributesOutput,
} from "aws-amplify/auth";

interface DataContextType {
  userRegistrations: Map<string, RegistrationSummary>;
  setUserRegistrations: React.Dispatch<
    React.SetStateAction<Map<string, RegistrationSummary>>
  >;
  refreshRegistrations: () => void;
  attributes: FetchUserAttributesOutput;
}

const DataContext = createContext<DataContextType | undefined>(undefined);

export const DataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [userRegistrations, setUserRegistrations] = useState<
    Map<string, RegistrationSummary>
  >(new Map());
  const [attributes, setAttributes] = useState<FetchUserAttributesOutput>({});

  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
  ]);

  useEffect(() => {
    refreshRegistrations();
    const loadAttributes = async () => {
      try {
        const result: FetchUserAttributesOutput = await fetchUserAttributes();
        setAttributes(result);
      } catch (e) {
        // Unauthenticated
        setAttributes({});
      }
    };
    loadAttributes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus, user]);

  const refreshRegistrations = () => {
    if (authStatus !== `authenticated`) {
      setUserRegistrations(new Map());
      return;
    }
    listCurrentUserRegistration({}).then(
      (res) => {
        setUserRegistrations(
          res.registrations?.reduce((map, item) => {
            map.set(item.baptism!!.baptismId!!, item);
            return map;
          }, new Map<string, RegistrationSummary>()) ?? new Map(),
        );
      },
      (err) => {
        console.log(err);
      },
    );
  };

  return (
    <DataContext.Provider
      value={{
        userRegistrations,
        setUserRegistrations,
        refreshRegistrations,
        attributes,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useUserData = (): DataContextType => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useList must be used within a ListProvider");
  }
  return context;
};
